export default {
    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    },
    getHash(str) {
        const crypto = require('crypto')
        return crypto.createHash('sha1').update(str).digest('hex')
    },
    getNotionLink(notion_id) {
        if (!!notion_id)
            return 'https://www.notion.so/' + notion_id.replace(/-/g, '')
        else
            return null
    },
    getDateOfISOWeek(y, w, d) {
        let simple = new Date(y, 0, d + (w - 1) * 7);
        let dow = simple.getDay();
        let ISOweekStart = simple;
        if (dow <= 4)
            ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
        else
            ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
        return ISOweekStart;
    },
    mapDynamicFields(namespaceProp, names) {
        return names.reduce((prev, name) => {
                let path = null
                let nameResult
                if (!!name && name.includes(':')) {
                    let nameArray = name.split(':')
                    path = nameArray[1]
                    nameResult = nameArray[0]
                } else {
                    path = name
                    nameResult = name
                }
                const field = {
                    get() {
                        const namespace = this[namespaceProp];
                        const getterPath = `${namespace}/getField`;
                        return this.$store.getters[getterPath](path);
                    },
                    set(value) {
                        const namespace = this[namespaceProp];
                        const mutationPath = `${namespace}/updateField`;
                        this.$store.commit(mutationPath, {path, value});
                    }
                };
                prev[nameResult] = field;
                return prev;
            }, {}
        )
    },
    mapDynamicGetters(namespaceProp, names) {
        return names.reduce((prev, name) => {
                const func = function () {
                    const namespace = this[namespaceProp];
                    const getterPath = `${namespace}/${name}`;
                    // console.log('mapDynamicGetters', getterPath)
                    return this.$store.getters[getterPath]
                }
                prev[name] = func;
                return prev;
            }, {}
        )
    },
    mapDynamicActions(namespaceProp, names) {
        return names.reduce((prev, name) => {
                const func =
                    function (params) {
                        const namespace = this[namespaceProp];
                        return this.$store.dispatch(namespace + '/' + name, params)
                    }
                prev[name] = func
                return prev;
            }, {}
        )
    },

    mapStoreFields(names) {
        // console.log('mapStoreFields', names)
        return names.reduce((prev, name) => {
                const path = name.split('/')[1];
                const namespace = name.split('/')[0]
                const field = {
                    get() {
                        const getterPath = `${namespace}/getField`;
                        return this.$store.getters[getterPath](path);
                    },
                    set(value) {
                        const mutationPath = `${namespace}/updateField`;
                        this.$store.commit(mutationPath, {path, value});
                    }
                };
                prev[`${namespace}_${path}`] = field;
                return prev;
            }, {}
        )
    },
    mapStoreGetters(names) {
        return names.reduce((prev, name) => {
                const path = name.split('/')[1];
                const namespace = name.split('/')[0]
                // console.log('mapStoreGetters reduce', namespace, path)
                const func = function () {
                    const getterPath = `${namespace}/${path}`;
                    // console.log('mapDynamicGetters', getterPath)
                    return this.$store.getters[getterPath]
                }
                prev[`${namespace}_${path}`] = func;
                return prev;
            }, {}
        )
    },
    mapStoreActions(names) {
        return names.reduce((prev, name) => {
                const path = name.split('/')[1];
                const namespace = name.split('/')[0]
                const func =
                    function (params) {
                        return this.$store.dispatch(namespace + '/' + path, params)
                    }
                prev[`${namespace}_${path}`] = func
                return prev;
            }, {}
        )
    },


    updateDeepDictionary(destination, source) {
        let updated = false
        function updateCommon(destination, source) {
            // console.log('updateCommon', destination, source)
            for (let key of Object.keys(destination)) {
                if (source[key] !== undefined) {
                    if ((destination[key] === null || destination[key].constructor === Object) &&
                        source[key] !== null && source[key].constructor === Object) {
                        if (destination[key] === null)
                            destination[key] = source[key]
                        else
                            updateCommon(destination[key], source[key])
                    } else
                        destination[key] = source[key]
                }
            }
        }

        // console.log('updateDeepDictionary', destination, source)
        if (source['uid'] === undefined)
            return updated
        if (Array.isArray(destination)) {
            // console.log('updateDeepDictionary is array')
            for (let element of destination) {
                // console.log('updateDeepDictionary array', element)
                updated = updated || this.updateDeepDictionary(element, source)
                // if (updated) console.log('updated updateDeepDictionary', element, source)
            }
            return updated
        }
        if (destination['uid'] !== undefined && destination['uid'] === source['uid']) {
            // console.log('updateDeepDictionary match')
            updateCommon(destination, source)
            return true
        }
        for (let key of Object.keys(destination)) {
            // console.log('updateDeepDictionary key', key)
            let sub_destination = destination[key]
            if (sub_destination !== null && sub_destination.constructor === Object) {
                // console.log('updateDeepDictionary dict')
                updated = updated || this.updateDeepDictionary(sub_destination, source)
            }
            if (sub_destination !== null && Array.isArray(sub_destination)) {
                // console.log('updateDeepDictionary array')
                updated = updated || this.updateDeepDictionary(sub_destination, source)
            }
        }
        return updated
    },

    createProxy(target, rawUid) {
        function checkIfValidUUID(param) {
            if (typeof param === 'string' || param instanceof String) {
                const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
                return regexExp.test(param)
            }
            return false
        }

        let current = this

        if (Array.isArray(target)) {
            const proxy = new Proxy(target, {
                get(target, key, receiver) {
                    return Reflect.get(target, key, receiver);
                },
                set(target, key, value, receiver) {
                    Reflect.set(target, key, current.createProxy(value, rawUid), receiver);
                    // Дополнительно вызывайте методы Vue для обновления реактивности (если нужно)
                    return true;
                },
            });
            return proxy
        }

        if (typeof target === 'object' && target !== null) {
            const proxy = new Proxy(target, {
                get(target, key, receiver) {
                    let references_uid = Reflect.get(target, 'references_uid', receiver);
                    let value = null;

                    if (!!references_uid) {
                        value = Reflect.get(references_uid, key, receiver);
                        if (checkIfValidUUID(value)) {
                            const proxy = current.createProxy(Reflect.get(rawUid, value, receiver), rawUid);
                            return proxy
                        }
                    }

                    if (value === null || value === undefined) {
                        value = Reflect.get(target, key, receiver);
                    }

                    if (Array.isArray(value)) {
                        // console.log('isArray', value)
                        let new_array = []
                        for (let item of value) {
                            let value_by_uid = Reflect.get(rawUid, item, receiver)
                            if (!!value_by_uid) {
                                const item_proxy = current.createProxy(value_by_uid, rawUid)
                                new_array.push(item_proxy)
                            } else
                                new_array.push(item)
                        }
                        const proxy = current.createProxy(new_array, rawUid)
                        // cache.set(target, proxy);
                        return proxy
                    }

                    return value;
                },
                set(target, key, value, receiver) {
                    Reflect.set(target, key, current.createProxy(value, rawUid), receiver);
                    // Дополнительно вызывайте методы Vue для обновления реактивности (если нужно)
                    return true;
                },
            });
            return proxy
        }

        return target
    }


}